'use strict';

const saAppLink = [
  'config',

  function (config) {
    const appUrls = {
      ios: config.iosAppUrl,
      android: config.androidAppUrl,
    };

    return {
      restrict: 'A',
      link: function ($scope, $element, $attrs) {
        $attrs.$set('href', appUrls[$attrs.saAppLink]);
        $attrs.$set('target', '_blank');
      }
    };
  }
];

export default saAppLink;



// WEBPACK FOOTER //
// ./app/src/directives/app_link.js